import { render, staticRenderFns } from "./AudioMedia.vue?vue&type=template&id=5bb90690&"
import script from "./AudioMedia.vue?vue&type=script&lang=js&"
export * from "./AudioMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports